import { useQueryClient } from "react-query";
import PropTypes from "prop-types";
import { useGlobalPrivateChannelListener } from "../Hooks/useGlobalPrivateChannelListener";

const ExpenseTotalRealtimeEvents = ({ parentType, parentId }) => {
  const queryClient = useQueryClient();

  const listener = ({ parent_type, parent_id }) => {
    queryClient.invalidateQueries(["expenses-user-total", parent_type, parent_id]);
  };

  const taskUpdatedHandler = ({ id }) => {
    if (parentType === "Task" && parentId === id) {
      queryClient.invalidateQueries(["expenses-user-total", "Task", id]);
    }
  };

  const projectUpdatedHandler = ({ id }) => {
    if (parentType === "Project" && parentId === id) {
      queryClient.invalidateQueries(["expenses-user-total", "Project", id]);
    }
  };

  const contextUpdatedListener = ({ id, type }) => {
    if (parentType === type && parentId === id) {
      queryClient.invalidateQueries(["expenses-user-total", type, id]);
    }
  };

  useGlobalPrivateChannelListener("ExpenseCreated", listener);
  useGlobalPrivateChannelListener("ExpenseMovedToProject", listener);
  useGlobalPrivateChannelListener("ExpenseRemovedFromProject", listener);
  useGlobalPrivateChannelListener("ExpenseUpdated", listener);
  useGlobalPrivateChannelListener("ExpenseMovedToTrash", listener);
  useGlobalPrivateChannelListener("ExpenseRestoredFromTrash", listener);
  useGlobalPrivateChannelListener("TaskUpdated", taskUpdatedHandler);
  useGlobalPrivateChannelListener("ProjectUpdated", projectUpdatedHandler);
  useGlobalPrivateChannelListener("TrackingContextUpdated", contextUpdatedListener);

  return null;
};

ExpenseTotalRealtimeEvents.propTypes = {
  parentId: PropTypes.number.isRequired,
  parentType: PropTypes.string.isRequired,
};

export default ExpenseTotalRealtimeEvents;
